export default __webpack_public_path__ + "4dde727f4d9cc8dd4cc16c7684d6f97b.png";